import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ILogItem} from '../models/log-item.class';
import {BaseApiService} from '../../common/base-api.service';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {DocumentTypeService} from '../../services/document-type.service';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {ILogItemSettings} from '../models/log-item-settings.class';

@Injectable({
  providedIn: 'root'
})
export class BugLoggerService extends BaseApiService {
  logItemsSubject = new BehaviorSubject<ILogItem[]>([]);
  totalIssuesCountSubject = new BehaviorSubject<number>(0);

  constructor(http: HttpClient, private router: Router, private documentTypeService: DocumentTypeService) {
    super(http, new SettingsProviderService('ecaApi'), 'BugLogger');
  }

  getLogItemSettings(): Observable<ILogItemSettings> {
    return this.post<ILogItemSettings>('GetLogItemSettings');
  }

  getLogItem(logItemId: string): Observable<ILogItem> {
    return this.post<ILogItem>('GetLogItem', {logItemId});
  }

  saveOrCreateLogItem(logItemFormData: FormData): Observable<ILogItem> {
    return this.post<ILogItem>('SaveOrCreateLogItem', logItemFormData);
  }

}
